<script setup lang="ts">
import { TabsTrigger, TabsTriggerProps, useForwardProps } from 'radix-vue'

const props = defineProps<TabsTriggerProps>()
const forwarded = useForwardProps(props)
</script>

<template>
  <TabsTrigger
    v-bind="forwarded"
    class="border-neutral-light-5 relative cursor-pointer border-t-1 border-b-1 px-4 py-3 text-sm font-bold whitespace-nowrap last:rounded-r-md last:border-r-1 nth-2:rounded-l-md nth-2:border-l-1"
  >
    <slot></slot>
  </TabsTrigger>
</template>
